import { render, staticRenderFns } from "./LabelItem.vue?vue&type=template&id=8e657746&"
import script from "./LabelItem.vue?vue&type=script&lang=js&"
export * from "./LabelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports